export default __webpack_public_path__ + "logo-dark-small.21fe8b02e8be835f2fe498319d18dc18.svg";